<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import CKEditor from "@ckeditor/ckeditor5-vue";
   import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
    
   export default {
      page: {
         title: "Terms & Conditions",
         meta: [
            {
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader, ckeditor: CKEditor.component },
      data() {
         return {
            title: "Terms & Conditions",
            items: [
               
               {
                  text: "Terms & Conditions",
                  active: true,
               },        
            ],
            terms:{},
           content: "", 
           error:"",

            type: "",
            user_id: "",
            errors: {},
            loading: false,

            cms: {
               editor: ClassicEditor,
               content: "",
               editorConfig: {
                    
               }
            }
         };
      },
      mounted() {
         this.clearLocalStorage();

      },
      created() {
         this.fetchTermsAndConditions();
      },

     methods: {

      clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },
         
  numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         noSpaces(event) {
            let keyCode = event.keyCode;
            if(keyCode == 32) {
               event.preventDefault();
            } else {
               return;
            }
         },

         alphaSpacesOnly(event) {
            let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32)) {
                 return;
            } else {
               event.preventDefault();
            }
         },

         getToken() {
                if (localStorage.getItem('medicino_admin')) {
                var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
                if(medicino_admin.token) {
                    this.token = medicino_admin.token;
                } else {
                    this.$swal("", "Failed to fetch token, please login again", "error");
                    this.$router.push({ name: "login" });
                }
                
                } else {
                this.$swal("", "Session expired, please login again", "error");
                this.$router.push({ name: "login" });
                }
            },  

         fetchTermsAndConditions() {
            let url = "api/cms/terms/details";         
            this.getToken();
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               let responseData = res.data.data;
                this.terms = responseData;
                     
            })
              .catch((error) => {
            console.log(error);
            console.log(error.response);
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");
               } 
               else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
            
         });
            //.finally(() => (this.loading = false));
         },
        
         updateTermsAndConditions() {
            this.getToken();           
             this.errors = {};

            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/cms/terms";

            let formData = new FormData();
            formData.append("content", this.terms.content); 

            this.loading = true;
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.$router.push({ name: 'cms.terms'});

               })
              .catch((error) => {
          console.log(error);
          console.log(error.response);
          if (error.response) {
            if (error.response.status == 422) {
              if (error.response.data) {
                this.errors = error.response.data.message;
              }
              this.$swal("", error.response.statusText, "error");
            } else if (error.response.status == 500) {
              this.$swal("", error.response.statusText, "error");
            } else if (error.response.status == 401) {
              this.$swal("", error.response.statusText, "error");
              this.$router.push({ name: "login" });
            } else {
              this.$swal("", "Something went wrong", "error");
            }
          } else {
            this.$swal("", error.message, "error");
          }
        })
        .finally(() => (this.loading = false));
    },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                 
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                     <form class="form-horizontal" role="form" @submit.prevent="updateTermsAndConditions()">
                        <div class="row">     
                    
                           <b-form-group class="col-lg-12 mb-3" >
                              <label>Content<span class="text-danger">*</span></label>
                              <ckeditor v-model="terms.content" :editor="cms.editor" :config="cms.editorConfig"></ckeditor> 
                           </b-form-group> 
                            <div v-if="errors.content" class="text-danger">
                              <div v-for="(error, index) in errors.content" :key="index">{{ error }}</div>
                           </div>    
                          </div>

                        <div class="row mt-3">
                           <div class="12">
                              <div v-if="loading" class="page-loader">
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                              <div v-else>
                                 <button class="btn btn-primary me-2" type="submit">Update</button>
                              </div>
                           </div>
                        </div>
                     </form>

                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>

<style scoped>
   .page-loader {
      display: flex;
      align-items: center;
      padding: 10px 0;
   }
   .page-loader img {
      width: 50px;
      height: 50px;
   }
</style>
